var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPocketCasts = function SvgPocketCasts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 32c0 17.673-14.327 32-32 32C14.326 64 0 49.673 0 32 0 14.326 14.326 0 32 0c17.673 0 32 14.326 32 32Z",
    fill: "#F43E37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.111 32C7.111 18.254 18.254 7.111 32 7.111c13.746 0 24.889 11.143 24.889 24.889h-6.222c0-10.31-8.358-18.667-18.667-18.667-10.31 0-18.667 8.358-18.667 18.667 0 10.31 8.358 18.667 18.667 18.667v6.222C18.254 56.889 7.111 45.746 7.111 32ZM32 46.933c-8.247 0-14.933-6.685-14.933-14.933 0-8.247 6.686-14.933 14.933-14.933 8.248 0 14.933 6.686 14.933 14.933h-5.43A9.503 9.503 0 1 0 32 41.503v5.43Z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPocketCasts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "e2078fa6f2ac12b8ec842d536f3551d7.svg";